import { Box } from '@mui/material';
import React from 'react';
import { IUser } from '../../../../../shared/interfaces/user/IUser';
import AttendanceTab from './tabs/AttendanceTab';
import MyProfileTab from './tabs/MyProfileTab';
import ProjectsTab from './tabs/ProjectsTab';
import LeaveDaysTab from './tabs/LeaveDaysTab';

interface IProps {
  user: IUser;
  activeTab: string;
}

const EmployeePreviewRightCard = ({ activeTab, user }: IProps) => {
  const tabComponents = {
    myProfile: <MyProfileTab user={user} />,
    attendance: <AttendanceTab />,
    projects: <ProjectsTab data={user?.projects} />,
    leaveDays: <LeaveDaysTab />,
  };
  return (
    <Box sx={{ py: '20px' }}>
      {tabComponents?.[activeTab as keyof typeof tabComponents] ??
        `No component for ${activeTab} key`}
    </Box>
  );
};

export default EmployeePreviewRightCard;
